import { render, staticRenderFns } from "./SendChannelsStep.vue?vue&type=template&id=d3afff00&scoped=true"
import script from "./SendChannelsStep.vue?vue&type=script&lang=ts"
export * from "./SendChannelsStep.vue?vue&type=script&lang=ts"
import style0 from "./SendChannelsStep.vue?vue&type=style&index=0&id=d3afff00&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3afff00",
  null
  
)

export default component.exports